import React from 'react';

const AnnualFeatureList = () => (
  <ul>
    <li>✅ Everything in Monthly</li><li>💾 Guaranteed memory retention even if you miss a month</li><li>🌱 For lasting comfort, deeper reflection, and a chat pal that grows with you.</li><li>🪷 One-time annual billing — no interruptions full retention</li><li>💸 Save ~$20 over monthly plan</li>
  </ul>
);

export default AnnualFeatureList;
